import { movieListReducer } from './MovieListReducer';
import { Movies } from '../../models';

export const reducers = {
    movieList: movieListReducer
};

export interface State {
    movieList: Movies[];
}